<div class="w-full h-[100px] flex justify-center items-center">
  <app-loader-dots></app-loader-dots>
</div>
